@let btn = config();

@if (menuItem()) {
    @if (btn.isExternalLink) {
        <a
            mat-menu-item
            [class]="btn.customClass || ''"
            [target]="target()"
            [href]="btn.link"
            [attr.aria-label]="ariaLabel()"
        >
            <ng-container [ngTemplateOutlet]="content" />
        </a>
    } @else {
        <a
            mat-menu-item
            routerLinkActive="cms-btn--active"
            [class]="btn.customClass || ''"
            [target]="target()"
            [routerLink]="routerLink()"
            [queryParams]="queryParams()"
            [routerLinkActiveOptions]="activeMatchOptions"
            [attr.aria-label]="ariaLabel()"
        >
            <ng-container [ngTemplateOutlet]="content" />
        </a>
    }
} @else if (isLink()) {
    @if (btn.isExternalLink) {
        <a
            class="cms-btn cms-btn--link"
            [class]="btn.customClass || ''"
            [target]="target()"
            [href]="btn.link"
            [attr.aria-label]="ariaLabel()"
        >
            <ng-container [ngTemplateOutlet]="content" />
        </a>
    } @else {
        <a
            class="cms-btn cms-btn--link"
            routerLinkActive="cms-btn--active"
            [class]="btn.customClass || ''"
            [target]="target()"
            [routerLink]="routerLink()"
            [queryParams]="queryParams()"
            [routerLinkActiveOptions]="activeMatchOptions"
            [attr.aria-label]="ariaLabel()"
        >
            <ng-container [ngTemplateOutlet]="content" />
        </a>
    }
} @else {
    @if (btn.isExternalLink) {
        <a
            class="cms-btn"
            mat-button
            [class]="btn.style + ' ' + (btn.customClass || '')"
            [target]="target()"
            [href]="btn.link"
            [attr.aria-label]="ariaLabel()"
        >
            <ng-container [ngTemplateOutlet]="content" />
        </a>
    } @else {
        <a
            class="cms-btn"
            mat-button
            routerLinkActive="cms-btn--active"
            [class]="btn.style + ' ' + (btn.customClass || '')"
            [target]="target()"
            [routerLink]="routerLink()"
            [queryParams]="queryParams()"
            [routerLinkActiveOptions]="activeMatchOptions"
            [attr.aria-label]="ariaLabel()"
        >
            <ng-container [ngTemplateOutlet]="content" />
        </a>
    }
}

<ng-template #content>
    <div class="cms-btn__text">{{ btn.label }}</div>
    <cms-image
        class="cms-btn__icon"
        [media]="btn.buttonIcon"
        [fallbackAlt]="''"
    />
</ng-template>
